/*!
* @supportpro/pollcast v1.1.2
* Released under the MIT License.
*/
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Pollcast = factory());
})(this, (function () { 'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function (obj) {
                return typeof obj;
            };
        } else {
            _typeof = function (obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
        }
        return _typeof(obj);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }
    function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) {
            Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
            });
        } else {
            obj[key] = value;
        }
        return obj;
    }
    function _extends() {
        _extends = Object.assign || function (target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];
                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _assertThisInitialized(self) {
        if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
    }
    function _possibleConstructorReturn(self, call) {
        if (call && (typeof call === "object" || typeof call === "function")) {
            return call;
        } else if (call !== void 0) {
            throw new TypeError("Derived constructors may only return object or undefined");
        }
        return _assertThisInitialized(self);
    }
    function _createSuper(Derived) {
        var hasNativeReflectConstruct = _isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = _getPrototypeOf(Derived),
                result;
            if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else {
                result = Super.apply(this, arguments);
            }
            return _possibleConstructorReturn(this, result);
        };
    }
    function _superPropBase(object, property) {
        while (!Object.prototype.hasOwnProperty.call(object, property)) {
            object = _getPrototypeOf(object);
            if (object === null) break;
        }
        return object;
    }
    function _get(target, property, receiver) {
        if (typeof Reflect !== "undefined" && Reflect.get) {
            _get = Reflect.get;
        } else {
            _get = function _get(target, property, receiver) {
                var base = _superPropBase(target, property);
                if (!base) return;
                var desc = Object.getOwnPropertyDescriptor(base, property);
                if (desc.get) {
                    return desc.get.call(receiver);
                }
                return desc.value;
            };
        }
        return _get(target, property, receiver || target);
    }
    var Connector$1 = /*#__PURE__*/function () {
        /**
         * Default connector options.
         */
        /**
         * Create a new class instance.
         */
        function Connector(options) {
            _classCallCheck(this, Connector);
            _defineProperty(this, "_defaultOptions", {
                auth: {
                    headers: {}
                },
                authEndpoint: '/broadcasting/auth',
                broadcaster: 'pusher',
                csrfToken: null,
                host: null,
                key: null,
                namespace: 'App.Events'
            });
            this.setOptions(options);
            this.connect();
        }
        /**
         * Merge the custom options with the defaults.
         */
        _createClass(Connector, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.options = _extends(this._defaultOptions, options);
                if (this.csrfToken()) {
                    this.options.auth.headers['X-CSRF-TOKEN'] = this.csrfToken();
                }
                return options;
            }
            /**
             * Extract the CSRF token from the page.
             */
        }, {
            key: "csrfToken",
            value: function csrfToken() {
                var selector;
                if (typeof window !== 'undefined' && window['Laravel'] && window['Laravel'].csrfToken) {
                    return window['Laravel'].csrfToken;
                } else if (this.options.csrfToken) {
                    return this.options.csrfToken;
                } else if (typeof document !== 'undefined' && typeof document.querySelector === 'function' && (selector = document.querySelector('meta[name="csrf-token"]'))) {
                    return selector.getAttribute('content');
                }
                return null;
            }
            /**
             * Create a fresh connection.
             */
        }]);
        return Connector;
    }();
    /**
     * This class represents a basic channel.
     */
    var Channel$1 = /*#__PURE__*/function () {
        function Channel() {
            _classCallCheck(this, Channel);
        }
        _createClass(Channel, [{
            key: "listenForWhisper",
            value:
                /**
                 * Listen for a whisper event on the channel instance.
                 */
                function listenForWhisper(event, callback) {
                    return this.listen('.client-' + event, callback);
                }
            /**
             * Listen for an event on the channel instance.
             */
        }, {
            key: "notification",
            value: function notification(callback) {
                return this.listen('.Illuminate\\Notifications\\Events\\BroadcastNotificationCreated', callback);
            }
            /**
             * Stop listening to an event on the channel instance.
             */
        }, {
            key: "stopListeningForWhisper",
            value:
                /**
                 * Stop listening for a whisper event on the channel instance.
                 */
                function stopListeningForWhisper(event, callback) {
                    return this.stopListening('.client-' + event, callback);
                }
            /**
             * Register a callback to be called anytime a subscription succeeds.
             */
        }]);
        return Channel;
    }();
    /**
     * Event name formatter
     */
    var EventFormatter = /*#__PURE__*/function () {
        /**
         * Event namespace.
         */
        /**
         * Create a new class instance.
         */
        function EventFormatter(namespace) {
            _classCallCheck(this, EventFormatter);
            this.setNamespace(namespace);
        }
        /**
         * Format the given event name.
         */
        _createClass(EventFormatter, [{
            key: "format",
            value: function format(event) {
                if (event.charAt(0) === '.' || event.charAt(0) === '\\') {
                    return event.substr(1);
                } else if (this.namespace) {
                    event = this.namespace + '.' + event;
                }
                return event.replace(/\./g, '\\');
            }
            /**
             * Set the event namespace.
             */
        }, {
            key: "setNamespace",
            value: function setNamespace(value) {
                this.namespace = value;
            }
        }]);
        return EventFormatter;
    }();
    /**
     * This class represents a Socket.io channel.
     */
    var Channel = /*#__PURE__*/function (_BaseChannel) {
        _inherits(Channel, _BaseChannel);
        var _super = _createSuper(Channel);
        /**
         * Create a new class instance.
         */
        function Channel(socket, name, options) {
            var _this;
            _classCallCheck(this, Channel);
            _this = _super.call(this);
            _this.name = name;
            _this.socket = socket;
            _this.options = options;
            _this.eventFormatter = new EventFormatter(_this.options.namespace);
            _this.subscribe();
            return _this;
        }
        /**
         * Subscribe to a channel.
         */
        _createClass(Channel, [{
            key: "subscribe",
            value: function subscribe() {
                this.socket.subscribe(this.name);
            }
            /**
             * Unsubscribe from channel.
             */
        }, {
            key: "unsubscribe",
            value: function unsubscribe() {
                this.socket.unsubscribe(this.name);
            }
            /**
             * Listen for an event on the channel instance.
             */
        }, {
            key: "listen",
            value: function listen(event, callback) {
                this.socket.on(this.name, this.eventFormatter.format(event), callback);
                return this;
            }
            /**
             * Stop listening for an event on the channel instance.
             */
        }, {
            key: "stopListening",
            value: function stopListening(event, callback) {
                this.socket.off(this.name, this.eventFormatter.format(event), callback);
                return this;
            }
            /**
             * Register a callback to be called anytime a subscription succeeds.
             */
        }, {
            key: "subscribed",
            value: function subscribed(callback) {
                this.socket.on(this.name, 'pollcast:subscription_succeeded', callback);
                return this;
            }
            /**
             * Register a callback to be called anytime an error occurs.
             */
        }, {
            key: "error",
            value: function error(callback) {
                return this;
            }
        }]);
        return Channel;
    }(Channel$1);
    var PrivateChannel = /*#__PURE__*/function (_Channel) {
        _inherits(PrivateChannel, _Channel);
        var _super = _createSuper(PrivateChannel);
        function PrivateChannel() {
            _classCallCheck(this, PrivateChannel);
            return _super.apply(this, arguments);
        }
        _createClass(PrivateChannel, [{
            key: "whisper",
            value:
                /**
                 * Trigger client event on the channel.
                 */
                function whisper(eventName, data) {
                    this.socket.emit(this.name, "client-".concat(eventName), data);
                    return this;
                }
        }]);
        return PrivateChannel;
    }(Channel);
    var PresenceChannel = /*#__PURE__*/function (_PrivateChannel) {
        _inherits(PresenceChannel, _PrivateChannel);
        var _super = _createSuper(PresenceChannel);
        function PresenceChannel() {
            _classCallCheck(this, PresenceChannel);
            return _super.apply(this, arguments);
        }
        _createClass(PresenceChannel, [{
            key: "here",
            value:
                /**
                 * Listen for when you've successfully joined a channel.
                 */
                function here(callback) {
                    this.socket.on(this.name, 'pollcast:subscription_succeeded', function (members) {
                        callback(members.map(function (m) {
                            return m.user_info;
                        }));
                    });
                    return this;
                }
            /**
             * Listen for someone joining the channel.
             */
        }, {
            key: "joining",
            value: function joining(callback) {
                this.socket.on(this.name, 'pollcast:member_added', function (member) {
                    return callback(member.user_info);
                });
                return this;
            }
            /**
             * Listen for someone leaving the channel.
             */
        }, {
            key: "leaving",
            value: function leaving(callback) {
                this.socket.on(this.name, 'pollcast:member_removed', function (member) {
                    return callback(member.user_info);
                });
                return this;
            }
        }]);
        return PresenceChannel;
    }(PrivateChannel);
    /**
     * @see https://stackoverflow.com/a/32108184
     */
    var isEmptyObject = function isEmptyObject(obj) {
        return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
    };
    /**
     * URL encode a key value pair.
     */
    var urlEncode = function urlEncode(key, value) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(value);
    };
    /**
     * URL encode an object.
     */
    var urlEncodeObject = function urlEncodeObject(obj, prefix) {
        var str = [];
        Object.keys(obj).forEach(function (key, index) {
            var item;
            var k = prefix ? prefix + '[' + key + ']' : key;
            var v = obj[key];
            if (_typeof(v) === 'object') {
                item = isEmptyObject(v) ? urlEncode(k, '') : urlEncodeObject(v, k);
            } else {
                item = urlEncode(k, v);
            }
            str.push(item);
        });
        return str.join('&');
    };
    /**
     * Create a cryptographically unsecure UUID v4 identifier.
     * Use https://www.npmjs.com/package/uuid for something more reliable.
     *
     * @see https://stackoverflow.com/a/2117523
     */
    var uuid = function uuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0;
            var v = c === 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    };
    var Request = /*#__PURE__*/function () {
        function Request(method, url) {
            _classCallCheck(this, Request);
            this.xhr = new window.XMLHttpRequest();
            this.xhr.open(method, url);
            this.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            this.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        }
        _createClass(Request, [{
            key: "success",
            value: function success(cb) {
                var self = this;
                this.xhr.addEventListener('load', function () {
                    if (self.xhr.readyState > 3 && self.xhr.status === 200) {
                        cb(self.xhr);
                    }
                });
                return this;
            }
        }, {
            key: "fail",
            value: function fail(cb) {
                var self = this;
                this.xhr.addEventListener('load', function () {
                    if (self.xhr.readyState > 3 && self.xhr.status !== 200) {
                        cb(self.xhr);
                    }
                });
                return this;
            }
        }, {
            key: "always",
            value: function always(cb) {
                var self = this;
                this.xhr.addEventListener('loadend', function (e) {
                    cb(self.xhr, e);
                });
                return this;
            }
        }, {
            key: "setRequestHeader",
            value: function setRequestHeader(name, value) {
                this.xhr.setRequestHeader(name, value);
                return this;
            }
        }, {
            key: "send",
            value: function send(data) {
                var encodedData;
                if (typeof data !== 'undefined') {
                    encodedData = urlEncodeObject(data);
                }
                this.xhr.send(encodedData || null);
            }
        }, {
            key: "abort",
            value: function abort() {
                this.xhr.abort();
            }
        }]);
        return Request;
    }();
    var LocalStorage = /*#__PURE__*/function () {
        function LocalStorage(key) {
            _classCallCheck(this, LocalStorage);
            this.key = key;
        }
        _createClass(LocalStorage, [{
            key: "get",
            value: function get() {
                var data = localStorage.getItem(this.key);
                if (data === null) {
                    return {};
                }
                try {
                    data = JSON.parse(data);
                    if (_typeof(data) === 'object') {
                        return data;
                    }
                    return {};
                } catch (err) {
                    return {};
                }
            }
        }, {
            key: "set",
            value: function set(key, value) {
                var data = this.get();
                data[key] = value;
                localStorage.setItem(this.key, JSON.stringify(data));
            }
        }]);
        return LocalStorage;
    }();
    var UniversalTime = /*#__PURE__*/function () {
        function UniversalTime() {
            _classCallCheck(this, UniversalTime);
            this.storage = new LocalStorage('universal_time');
        }
        _createClass(UniversalTime, [{
            key: "setTime",
            value: function setTime(time) {
                this.storage.set('time', time);
            }
        }, {
            key: "getTime",
            value: function getTime() {
                return this.storage.get().time || '';
            }
        }]);
        return UniversalTime;
    }();
    /**
     * This class is static as we want it to act as a singleton.
     * No matter how many PollcastConnector instances you create the windowId should remain the same.
     */
    var WindowVisibility = /*#__PURE__*/function () {
        function WindowVisibility() {
            _classCallCheck(this, WindowVisibility);
        }
        _createClass(WindowVisibility, null, [{
            key: "setActive",
            value: function setActive() {
                this.storage.set('lastActive', this.windowId);
            }
        }, {
            key: "isActive",
            value: function isActive() {
                return this.storage.get().lastActive === this.windowId;
            }
        }]);
        return WindowVisibility;
    }();
    WindowVisibility.windowId = uuid();
    WindowVisibility.storage = new LocalStorage('window-visibility');
    WindowVisibility.setActive();
    window.addEventListener('visibilitychange', function () {
        if (!document.hidden) {
            WindowVisibility.setActive();
        }
    });
    var Socket = /*#__PURE__*/function () {
        function Socket(options, csrfToken) {
            _classCallCheck(this, Socket);
            /**
             * Socket ID.
             */
            this.id = '';
            /**
             * Poll for data which has been created since this timestamp.
             */
            this.universalTime = new UniversalTime();
            /**
             * Subscribed channels.
             */
            this.channels = {};
            this.options = options;
            this.options.csrfToken = csrfToken;
        }
        /**
         * Connect to the server, start xhr-polling.
         */
        _createClass(Socket, [{
            key: "connect",
            value: function connect() {
                var self = this;
                this.request = new Request('POST', this.options.routes.connect);
                this.request.success(function (xhr) {
                    var response = JSON.parse(xhr.responseText);
                    if (response.status !== 'success') {
                        return;
                    }
                    self.universalTime.setTime(response.time);
                    self.id = response.id;
                    self.poll();
                }).send({
                    _token: this.options.csrfToken
                });
            }
        }, {
            key: "subscribed",
            get: function get() {
                return this.channels;
            }
            /**
             * Join a channel.
             */
        }, {
            key: "subscribe",
            value: function subscribe(channel) {
                if (!Object.hasOwnProperty.call(this.channels, channel)) {
                    this.channels[channel] = {};
                }
                var request = new Request('POST', this.options.routes.subscribe);
                request.send({
                    channel_name: channel,
                    _token: this.options.csrfToken
                });
            }
            /**
             * Leave a channel.
             */
        }, {
            key: "unsubscribe",
            value: function unsubscribe(channel) {
                var self = this;
                var request = new Request('POST', this.options.routes.unsubscribe);
                request.success(function () {
                    return delete self.channels[channel];
                }).send({
                    channel_name: channel,
                    _token: this.options.csrfToken
                });
            }
            /**
             * Listen for an event on the channel.
             */
        }, {
            key: "on",
            value: function on(channel, event, callback) {
                if (!Object.hasOwnProperty.call(this.channels, channel)) {
                    return;
                }
                if (!Object.hasOwnProperty.call(this.channels[channel], event)) {
                    this.channels[channel][event] = [];
                }
                this.channels[channel][event].push(callback);
            }
            /**
             * Stop listening for a given event on the channel.
             */
        }, {
            key: "off",
            value: function off(channel, event, callback) {
                if (!Object.hasOwnProperty.call(this.channels, channel) || !Object.hasOwnProperty.call(this.channels[channel], event)) {
                    return;
                }
                if (callback) {
                    this.channels[channel][event] = this.channels[channel][event].filter(function (cb) {
                        return cb !== callback;
                    });
                } else {
                    delete this.channels[channel][event];
                }
            }
            /**
             * Publish a message from the client to the server.
             */
        }, {
            key: "emit",
            value: function emit(channel, event, data) {
                var request = new Request('POST', this.options.routes.publish);
                request.send({
                    channel_name: channel,
                    event: event,
                    data: data,
                    _token: this.options.csrfToken
                });
            }
            /**
             * Disconnect the client from the server.
             */
        }, {
            key: "disconnect",
            value: function disconnect() {
                if (this.request) {
                    this.request.abort();
                }
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = undefined;
                }
            }
        }, {
            key: "dispatch",
            value: function dispatch(channel, event, data) {
                if (!Object.hasOwnProperty.call(this.channels, channel) || !Object.hasOwnProperty.call(this.channels[channel], event)) {
                    return;
                }
                var events = this.channels[channel][event];
                for (var i = 0; i < events.length; i++) {
                    events[i](data);
                }
            }
        }, {
            key: "poll",
            value: function poll() {
                var _this = this;
                var self = this;
                var channels = {};
                for (var channel in this.channels) {
                    channels[channel] = Object.keys(this.channels[channel]);
                }
                if (!WindowVisibility.isActive() || isEmptyObject(channels)) {
                    /* istanbul ignore next */
                    self.timer = setTimeout(function () {
                        return self.poll();
                    }, this.options.polling);
                    return;
                }
                this.request = new Request('POST', this.options.routes.receive);
                this.request.success(function (xhr) {
                    return self.fireEvents(xhr.responseText);
                }).fail(function (xhr) {
                    // https://github.com/supportpro/pollcast/issues/7
                    if (xhr.status === 404) {
                        for (var _channel in _this.channels) {
                            self.subscribe(_channel);
                        }
                    }
                }).always(function () {
                    /* istanbul ignore next */
                    self.timer = setTimeout(function () {
                        return self.poll();
                    }, self.options.polling);
                }).send({
                    time: this.universalTime.getTime(),
                    channels: channels,
                    _token: this.options.csrfToken
                });
            }
        }, {
            key: "fireEvents",
            value: function fireEvents(response) {
                var _this2 = this;
                response = JSON.parse(response);
                if (response.status !== 'success') {
                    return;
                }
                this.universalTime.setTime(response.time);
                Object.keys(response.events).forEach(function (event) {
                    var item = response.events[event];
                    _this2.dispatch(item.channel.name, item.event, item.payload);
                });
            }
        }]);
        return Socket;
    }();
    var Connector = /*#__PURE__*/function (_BaseConnector) {
        _inherits(Connector, _BaseConnector);
        var _super = _createSuper(Connector);
        function Connector() {
            var _this;
            _classCallCheck(this, Connector);
            _this = _super.apply(this, arguments);
            /**
             * All of the subscribed channel names.
             */
            _this.channels = {};
            return _this;
        }
        /**
         * Merge the custom options with the defaults.
         */
        _createClass(Connector, [{
            key: "setOptions",
            value: function setOptions(options) {
                _get(_getPrototypeOf(Connector.prototype), "setOptions", this).call(this, options);
                this.options = _extends({
                    routes: {
                        connect: '',
                        receive: '',
                        publish: '',
                        subscribe: '',
                        unsubscribe: ''
                    },
                    polling: 5000
                }, this.options);
                return options;
            }
            /**
             * Create a fresh Socket.io connection.
             */
        }, {
            key: "connect",
            value: function connect() {
                this.socket = new Socket(this.options, this.csrfToken());
                this.socket.connect();
            }
            /**
             * Get a channel instance by name.
             */
        }, {
            key: "channel",
            value: function channel(name) {
                if (!this.channels[name]) {
                    this.channels[name] = new Channel(this.socket, name, this.options);
                }
                return this.channels[name];
            }
            /**
             * Get a private channel instance by name.
             */
        }, {
            key: "privateChannel",
            value: function privateChannel(name) {
                if (!this.channels['private-' + name]) {
                    this.channels['private-' + name] = new PrivateChannel(this.socket, 'private-' + name, this.options);
                }
                return this.channels['private-' + name];
            }
            /**
             * Get a presence channel instance by name.
             */
        }, {
            key: "presenceChannel",
            value: function presenceChannel(name) {
                if (!this.channels['presence-' + name]) {
                    this.channels['presence-' + name] = new PresenceChannel(this.socket, 'presence-' + name, this.options);
                }
                return this.channels['presence-' + name];
            }
            /**
             * Leave the given channel, as well as its private and presence variants.
             */
        }, {
            key: "leave",
            value: function leave(name) {
                var _this2 = this;
                var channels = [name, 'private-' + name, 'presence-' + name];
                channels.forEach(function (name) {
                    _this2.leaveChannel(name);
                });
            }
            /**
             * Leave the given channel.
             */
        }, {
            key: "leaveChannel",
            value: function leaveChannel(name) {
                if (this.channels[name]) {
                    this.channels[name].unsubscribe();
                    delete this.channels[name];
                }
            }
            /**
             * Get the socket ID for the connection.
             */
        }, {
            key: "socketId",
            value: function socketId() {
                return this.socket ? this.socket.id : '';
            }
            /**
             * Disconnect connection.
             */
        }, {
            key: "disconnect",
            value: function disconnect() {
                if (this.socket) {
                    this.socket.disconnect();
                }
            }
        }]);
        return Connector;
    }(Connector$1);
    var PollcastConnector = Connector;
    return PollcastConnector;
}));
